module.exports = __webpack_public_path__ + "static/media/isFour.cab76dfb.png";